import Vue from 'vue';
import TopBar from "components/TopBar.vue";
import Project from 'src/api/project';
export default Vue.extend({
    components: { TopBar },
    data() {
        return {
            success: false,
            verifying: true,
            error: '',
        };
    },
    async mounted() {
        // https://developer.surveymonkey.com/api/v3/#oauth-2-0-flow
        const data = {
            type: 'survey_monkey',
            enabled: true,
            details: {
                auth_code: this.$route.query.code,
            }
        };
        // The site isn't populated in the store for this page. This is because
        // Survey Monkey redirects here via the redirect uri and the redirect uri
        // *has* to be static, so it cannot include the site name. E.g. I can't
        // use https://app.kapiche.com/rstuart/survey-monkey-config/. I have to
        // use https://app.kapiche.com/survey-monkey-config?state=rstuart.
        // Therefore it's not populated in the store and not automatically
        // injected in our api call. I have to get the site name from the state
        // parameter in the redirect uri and manually add it in.
        const headers = { 'Site-Name': this.$route.query.state };
        try {
            await Project.createNewIntegration(data, headers);
            this.success = true;
        }
        catch (e) {
            this.success = false;
            this.error = `${e.statusText}: ${e.bodyText}`;
        }
        finally {
            this.verifying = false;
        }
    },
    methods: {
        close() {
            window.opener.location.reload();
            self.close();
        }
    },
});
